import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { readConsent } from "../lib/consent";

/**
 * Fires a first-party pageview beacon on every route change.
 *
 * No cookie is written and no identifier is read, so this runs without the
 * consent banner. If a visitor has actively rejected analytics we honour that
 * and stay silent.
 */
export function TrafficBeacon() {
  const { pathname } = useLocation();
  const last = useRef(null);

  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    if (last.current === pathname) return; // guards StrictMode double effects
    last.current = pathname;

    const consent = readConsent();
    if (consent && consent.analytics === false) return;

    api
      .post("/traffic/hit", { path: pathname, referrer: document.referrer || "" })
      .catch(() => {});
  }, [pathname]);

  return null;
}
